Webhooks:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/QueryLanguage"
  post:
    summary: Webhookの作成
    description: |
      Webhookを作成するAPIです。

      > ⚠️ Webhookは、1フォルダに1つのみ作成可能で、管理者または操作対象フォルダの副管理者でない場合はエラーを返します。
    operationId: createWebhook
    tags:
      - Webhook
    requestBody:
      content:
        application/x-www-form-urlencoded:
          schema:
            type: object
            required:
              - node
              - url
              - triggers
            properties:
              node:
                type: string
                description: フォルダのnodeです。
              auth_token:
                type: string
                description: |
                  [Webhookリクエストの](#Webhook-Payload)`Authorization`ヘッダーに使用される認証トークンです。
              url:
                type: string
                description: Webhookイベント通知先のURLです。
              triggers:
                $ref: '../schemas/webhook.yaml#/TriggerList'
    responses:
      "200":
        description: Webhookの作成成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: Webhookの作成失敗
        content:
          application/json:
            examples:
              Unauthorized:
                $ref: "../openapi/response.error.yaml#/unauthorized"
              Duplicated login:
                $ref: "../openapi/response.error.yaml#/duplicatedlogin"
              Expired token:
                $ref: "../openapi/response.error.yaml#/expiredtoken"
              Invalid request:
                $ref: "../openapi/response.error.yaml#/Invalidrequest"
              Webhook unavailable node:
                $ref: "../openapi/response.error.yaml#/Webhookunavailablenode"
              Has no authority:
                $ref: "../openapi/response.error.yaml#/Hasnoauthority"
              File or directory not exist:
                $ref: "../openapi/response.error.yaml#/FileOrFolderNotExists"
  get:
    summary: Webhookリストの照会
    description: |
      登録されているWebhookのリストを照会します。

      > ⚠️ フォルダに対して副管理者権限を持つユーザーのみWebhookリストを照会できます。
      > 
      > 管理者の場合は、すべてのWebhookのリストを照会できます。
    operationId: findWebhooks
    tags:
      - Webhook
    responses:
      "200":
        description: Webhookリストの照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: Webhookリストの照会失敗
        content:
          application/json:
            examples:
              Internal server error:
                $ref: "../openapi/response.error.yaml#/internalservererror"
              Unauthorized:
                $ref: "../openapi/response.error.yaml#/unauthorized"
              Duplicated login:
                $ref: "../openapi/response.error.yaml#/duplicatedlogin"
              Expired token:
                $ref: "../openapi/response.error.yaml#/expiredtoken"

Webhook:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/QueryLanguage"
    - name: node
      in: path
      required: true
      description: フォルダのnodeです。
      schema:
        type: string
  get:
    summary: Webhookの照会
    description: |
      指定したフォルダに登録されているWebhookのリストを照会します。

      > ⚠️ 管理者または操作対象フォルダの副管理者でない場合はエラーを返します。
    operationId: getWebhook
    tags:
      - Webhook
    responses:
      "200":
        description: Webhookの照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: Webhookの照会失敗
        content:
          application/json:
            examples:
              Unauthorized:
                $ref: "../openapi/response.error.yaml#/unauthorized"
              Duplicated login:
                $ref: "../openapi/response.error.yaml#/duplicatedlogin"
              Expired token:
                $ref: "../openapi/response.error.yaml#/expiredtoken"
              Webhook unavailable node:
                $ref: "../openapi/response.error.yaml#/Webhookunavailablenodev"
              Has no authority:
                $ref: "../openapi/response.error.yaml#/Hasnoauthorityv"
              File or directory not exist:
                $ref: "../openapi/response.error.yaml#/FileOrFolderNotExists"
              Webhook not exists:
                $ref: "../openapi/response.error.yaml#/Webhooknotexists"

  delete:
    summary: Webhookの削除
    description: |
      nodeに該当するフォルダに設定されているWebhookを削除します。

      > ⚠️ 管理者または操作対象フォルダの副管理者でない場合はエラーを返します。
    operationId: deleteWebhook
    tags:
      - Webhook
    responses:
      "200":
        description: Webhookの削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: Webhookの削除失敗
        content:
          application/json:
            examples:
              Unauthorized:
                $ref: "../openapi/response.error.yaml#/unauthorized"
              Duplicated login:
                $ref: "../openapi/response.error.yaml#/duplicatedlogin"
              Expired token:
                $ref: "../openapi/response.error.yaml#/expiredtoken"
              Webhook unavailable node:
                $ref: "../openapi/response.error.yaml#/Webhookunavailablenoded"
              Has no authority:
                $ref: "../openapi/response.error.yaml#/Hasnoauthorityd"
              Webhook not exists:
                $ref: "../openapi/response.error.yaml#/Webhooknotexists"
  put:
    summary: Webhookの修正
    description: |
      nodeに該当するフォルダに設定されているWebhookを修正します。

      > ⚠️ 管理者または操作対象フォルダの副管理者でない場合はエラーを返します。
    operationId: updateWebhook
    tags:
      - Webhook
    requestBody:
      content:
        application/x-www-form-urlencoded:
          schema:
            type: object
            required:
              - url
              - triggers
            properties:
              auth_token:
                type: string
                description: |
                  [Webhookリクエストの](#Webhook-Payload)`Authorization`ヘッダーに使用される認証トークンです。
              url:
                type: string
                description: Webhookイベント通知先のURLです。
              triggers:
                $ref: '../schemas/webhook.yaml#/TriggerList'
    responses:
      "200":
        description: Webhookの削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: Webhookの削除失敗
        content:
          application/json:
            examples:
              Unauthorized:
                $ref: "../openapi/response.error.yaml#/unauthorized"
              Duplicated login:
                $ref: "../openapi/response.error.yaml#/duplicatedlogin"
              Expired token:
                $ref: "../openapi/response.error.yaml#/expiredtoken"
              Invalid request:
                $ref: "../openapi/response.error.yaml#/Invalidrequest"
              Has no authority:
                $ref: "../openapi/response.error.yaml#/Hasnoauthorityf"
              File or directory not exist:
                $ref: "../openapi/response.error.yaml#/FileOrFolderNotExists"
              Webhook not exists:
                $ref: "../openapi/response.error.yaml#/Webhooknotexists"
